/**
 * Member Preferences API Client
 * Frontend API calls for the authenticated member to update their own preferences.
 */

import { apiCall } from '../api';
import type { MeResponse, UpdatePreferencesRequest } from '@/types/api';

/**
 * Update the authenticated member's preferences (e.g. mithaas).
 * Returns the refreshed user payload so callers can hydrate the auth store
 * without a separate /me request.
 */
export async function updateMyPreferences(
  data: UpdatePreferencesRequest
): Promise<MeResponse> {
  return await apiCall<MeResponse>('/api/auth/me/preferences', {
    method: 'PATCH',
    body: JSON.stringify(data),
  });
}
